module.exports = __webpack_public_path__ + "static/media/order.ee4fec11.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Svg/order.svg
// module id = 1075
// module chunks = 0